import React, { useEffect, useState } from "react";
import { OrderDisplayDto } from "../../../Model/OrderModel";
import { DateUtil } from "../../../Services/DateService/dateUtil";
import { OrderService } from "../../../Services/OrderService";
import { Subscription } from "rxjs";
import {
  ApiCallResponse,
  PageEventTypeEnum,
} from "../../../Model/ApiCallResponse";
import { ApiCallState } from "../../../Model/Enums/ApiCallState";
import { apiLoadingSubject, CompletedOrderStore } from "../../../Store";
import { useNavigate } from "react-router";
import noDataFound from "../../../Components/Images/NoData.jpeg";
import { showErrorToast } from "../../../utils/Toastify/ToastifyHandler";
import TableLoading from "../../LoadingComponent/TableLoading";

const NewOrderHistory = () => {
  const navigate = useNavigate();
  const [orders, setOrders] = useState<OrderDisplayDto[]>(
    new Array<OrderDisplayDto>()
  );
  const [isOrderLoading, setOrderLoading] = React.useState<boolean>(true);
  const date = new DateUtil();

  useEffect(() => {
    let orderSubscriber: Subscription;
    const orderService = new OrderService();

    orderService.getAllCompletedOrder();

    orderSubscriber = apiLoadingSubject.subscribe(
      (response: ApiCallResponse) => {
        if (PageEventTypeEnum.COMPLETED_ORDER === response.eventType) {
          switch (response.apiCallState) {
            case ApiCallState.LOADING:
              setOrderLoading(true);
              break;
            case ApiCallState.LOADING_SUCCESS:
              setOrders(CompletedOrderStore.getOrder());
              setOrderLoading(false);
              break;
            case ApiCallState.LOADING_ERROR:
              showErrorToast(response.data);
              setOrderLoading(false);
              break;
          }
        }
      }
    );

    return () => {
      if (orderSubscriber) {
        orderSubscriber.unsubscribe();
      }
    };
  }, []);
  const navigateToOrderDetail = (orderId: number) => {
    if (!isOrderLoading) {
      navigate(`/OrderDetails/${orderId}`);
    }
  };
  return (
    <>
      <div className="table-responsive mt-4 col-7 table-fixed scrollbar table-wrap">
        {isOrderLoading ? (
          <TableLoading />
        ) : orders.length > 0 ? (
          <table className="default_table table table-hover">
            <thead>
              <tr className="green_clr">
                <th scope="col">Customer Name</th>
                <th scope="col">Order ID</th>
                <th scope="col">Amount</th>
                <th scope="col">Ordered Date</th>
                <th scope="col">Delivered On</th>
                <th scope="col">Status</th>
                <th scope="col">Payment Status</th>
                <th scope="col">Order Details</th>
              </tr>
            </thead>
            <tbody>
              {orders.map((item) => {
                return (
                  <tr>
                    <td>
                      <div className="d-flex align-items-center justify-content-start">
                        <div className="order_user_name">
                          <p className="fs-14 fw-500 mb-0">{item.clientName}</p>
                          <p className="grey_clr fs-12 mb-0">
                            {item.clientEmail}
                          </p>
                        </div>
                      </div>
                    </td>
                    <td>{item.orderIdentifier}</td>
                    <td>{item.billingAmount}</td>
                    <td>{date.getDateFromEpoch(item.createdOn)}</td>
                    <td>
                      {date.calculateExpectedDeliveryDate(item.createdOn)}
                    </td>
                    <td className="green_clr">{item.orderStatus}</td>
                    <td>{item.paymentStatus}</td>
                    <td className="table-hover">
                      <span
                        role="button"
                        onClick={() => navigateToOrderDetail(item.id)}
                        className="text-primary"
                      >
                        View Order
                      </span>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        ) : (
          <div className="image-pos">
            <img className="no-data-found" src={noDataFound} alt="" />
          </div>
        )}
      </div>
    </>
  );
};

export default NewOrderHistory;
